const defaultState = {
  showLabelMarker: true,
};

const metadata = !!localStorage.getItem('_metadata') ? JSON.parse(localStorage.getItem('_metadata')!) : defaultState;

export default metadata;
